import React from "react";

function InjungYoutube() {
  return <div>유투브게시판</div>;
}

export default InjungYoutube;
